/**
 * External dependencies
 */
import React from 'react';
import classNames from 'classnames';
import Moment from 'moment';

/**
 * Interla dependencies
 */
import styles from './styles.scss';

const DateTime = ({ date, format = 'Do MMM, YYYY', className = 'ddmmyyyy', ...rest }) => {
    let time = null;

    try {
        time = Moment.unix(date).format(format);
    } catch (error) {
       
    }

    if (time=='Invalid date') {
        time = '-';
    }

    const classes = classNames('date', "date--" + className);
    
    return (
        <span className={classes}>
            {time}
        </span>
    );
};

DateTime.defaultProps = {
    format: 'MMMM Do YYYY',
    styles: {},
};

export default DateTime;
